import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardFooter, CardSubtitle, CardTitle, Col, Row} from 'reactstrap';

import JsonCompare from "../../../components/genericComponents/JsonCompare";
import { showToastCustom } from "../../../components/toast/customToast";
import { ButtonAccept, ButtonCancel, ButtonReject } from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import { confirmAlert } from "react-confirm-alert";
import { toDoTaskService } from "../../../jwt/_services/profile/toDoTaskService";
import { utilHelper } from "../../../jwt/_helpers";
import {
    APPROVE_ON_MSG, ARE_YOU_SHURE_TITLE, error, FORM, JS_ACTION_TYPE, JS_APPLICATION_DATE,
    JS_CHANGE_REQUESTED_BY, JS_REQUEST_STATUS, NO, REJECT_ONE_MSG, saveMsg, success, YES_CONFIRM
} from "../../../components/i18n/i18n";

export default function ToDoTaskForm(props) {
    const [savedData] = useState(props?.item);
    const [loading, setLoading] = useState(false);
    const [appName, setAppName] = useState( null )
    const [hasLog, setHasLog] = useState(true)

    useEffect(() => {
        let data = JSON.parse(savedData?.log?.data || null);

        if (!data) {
            setLoading(true);
            toDoTaskService.getItem(savedData.id)
                .then(result => {
                    if (result) {
                        data = result;

                        if(data != null && data['fbDataBase'])
                            setAppName(data['fbDataBase']['code'])
                        else
                            setHasLog( false )
                    }

                    setLoading(false);
                })
                .catch(ex => {
                    console.log(ex);
                    setLoading(false);
                })

        }

        if(data != null && data['fbDataBase'])
            setAppName(data['fbDataBase']['code'])
        else
            setHasLog( false )
    },[])


    // ----------------------------------------------
    //                  SUBMIT's
    // ----------------------------------------------
    const approve = () => {
        setLoading(true);

        return toDoTaskService.approveItem(savedData?.idTask)
            .then(_ => {
                showToastCustom(success, saveMsg);
                props.toggleParent();
            })
            .catch(errorMessage => showToastCustom(error, errorMessage))
            .finally( ()=> setLoading(false));
    }

    const reject = () => {
        setLoading(true);

        return toDoTaskService.rejectItem(savedData?.idTask)
            .then(_ => {
                showToastCustom(success, saveMsg);
                props.toggleParent();
            })
            .catch(errorMessage => showToastCustom(error, errorMessage))
            .finally( ()=> setLoading(false));
    }


    // ----------------------------------------------
    //                  CONFIRM
    // ----------------------------------------------
    const confirmApprove = () =>  confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{APPROVE_ON_MSG}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                approve().then(_ => {
                })
                onClose();
            }}>
                {YES_CONFIRM}
            </button>
        </div>
    });

    const confirmReject = () => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{REJECT_ONE_MSG}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                reject().then(_ => {
                })
                onClose();
            }}>
                {YES_CONFIRM}
            </button>
        </div>
    });

    return <Card>
        { loading && showLoader() }

        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}

            <div className="float-right">
                {
                    (hasLog && savedData?.status === 'PENDING') && <>
                        <ButtonAccept size={ 'sm' } onClick={confirmApprove}/>
                        <ButtonReject size={ 'sm' } onClick={confirmReject}/>
                    </>

                }
                <ButtonCancel size={ 'sm' } onClick={ props.toggleParent }/>
            </div>
        </CardTitle>

        <CardBody>
            <Row>
                <Col xs={3}>
                    <h4>{JS_CHANGE_REQUESTED_BY}:</h4>
                </Col>
                <Col>
                    <CardSubtitle>
                        {savedData?.name + " " + savedData?.lastName}
                    </CardSubtitle>
                </Col>
            </Row>
            <Row>
                <Col xs={3}>
                    <h4>{JS_ACTION_TYPE}:</h4>
                </Col>
                <Col>
                    { savedData?.action }
                </Col>
            </Row>
            <Row>
                <Col xs={3}>
                    <h4>{JS_APPLICATION_DATE}:</h4>
                </Col>
                <Col>
                    { utilHelper.dateFormatter(savedData?.registerDate) }
                </Col>
            </Row>
            <Row>
                <Col xs={3}>
                    <h4>{JS_REQUEST_STATUS}:</h4>
                </Col>
                <Col>
                    { savedData?.status }
                </Col>
            </Row>
            {
                appName != null &&  <Row>
                    <Col xs={3}>
                        <h4>APP:</h4>
                    </Col>
                    <Col>
                        { appName }
                    </Col>
                </Row>
            }

        </CardBody>

        <CardBody className="border-top">
            <JsonCompare
                model = { savedData?.model }
                actualData = { JSON.parse(savedData?.log?.actualData?.data || '{}') }
                newData = { JSON.parse(savedData?.log?.data || '{}') }
            />
        </CardBody>

        <CardFooter>
            <div className="float-right">
                <ButtonCancel onClick={props.toggleParent}/>
            </div>
            {
                (hasLog && savedData?.status === 'PENDING') &&
                <div className="float-right">
                    <ButtonAccept onClick={confirmApprove}/>
                    <ButtonReject onClick={confirmReject}/>
                </div>
            }
        </CardFooter>
    </Card>
}